export default __webpack_public_path__ + "static/media/Hired.e0a9e77d.svg";